module.exports = __webpack_public_path__ + "img/no_collaborative_list.072985cb.png";